module.exports = __webpack_public_path__ + "media/images/icons/facebook_sign_up-703ce045fd313620c541a15b1d000448.svg";